import { Component, OnInit, inject } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'
import { ICambioContrasena } from 'src/app/core/modules/sistema/models/ICambioContrasena.interface'

@Component({
  selector: 'app-cambio-contrasena',
  templateUrl: './cambio-contrasena.component.html',
  standalone: false,
  styleUrls: ['./cambio-contrasena.component.css'],
})
export class CambioContrasenaComponent implements OnInit {
  private fb = inject(FormBuilder)
  modalRef = inject(DynamicDialogRef)
  modalConfig = inject(DynamicDialogConfig)

  public fomularioModificacion: FormGroup | undefined
  public usuarioId: number = 0
  public cambioContrasena: ICambioContrasena | undefined

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[])

  constructor() {}

  ngOnInit(): void {
    this.usuarioId = this.modalConfig.data.usuarioId as number
    this.fomularioModificacion = this.crearFormulario(this.usuarioId)
  }

  public guardar() {
    this.modalRef.close(this.fomularioModificacion?.value as ICambioContrasena)
  }

  public cancelar() {
    this.modalRef.close()
  }

  private crearFormulario(usuarioId: number) {
    return this.fb.group({
      usuarioId: [usuarioId, Validators.required],
      contrasenaActual: [null, Validators.required],
      contrasenaNueva: [null, Validators.required],
    })
  }
}
